import React from 'react';
import { Login } from './components/Auth/Login';
import { Leaderboard, CombinedLeaderboard } from './components/Leaderboard';
import { Results } from './components/Results';
import { Scores } from './components/Scores';
import { Home } from './components/Home';
import { Route, Routes } from 'react-router-dom';
import { CheckIn, GroupCheckIn, QRCheckIn } from './components/CheckIn';
import { EventStatus } from './components/Events';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { EventInformation } from './components/EventInformation';
import { getUserRole, USER_ROLES } from './utils/auth';
import { ErrorPage } from './components/Layout/ErrorPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
    },
  },
})

const userRole = getUserRole();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
        <Routes>
          <Route path='/' Component={Home} />
          <Route path='/login' Component={Login} />
          <Route path='/checkin' Component={CheckIn} />
          <Route path='/group-checkin' Component={GroupCheckIn} />
          <Route path='/qr-checkin' Component={QRCheckIn} />
          <Route path='/leaderboard' Component={Leaderboard} />
          <Route path='/combined-leaderboard' Component={CombinedLeaderboard} />
          {
            (userRole === USER_ROLES.ADMIN || userRole === USER_ROLES.SUPER_ADMIN) && (
              <>
                <Route path='/scores' Component={Scores} />
                <Route path='/activate' Component={EventStatus} />
                <Route path='/results' Component={Results} />
                <Route path='/event-information' Component={EventInformation} />
              </>
            )
          }
          <Route path ='*' element={<ErrorPage />} />
        </Routes>
    </QueryClientProvider>
  );
}

export default App;
